// Mock data for Learn module

// Course categories matching the Vietnamese context
const COURSE_CATEGORIES = {
  AVIATION_SAFETY: 'an_ninh_an_toan',
  LOAD_BALANCING: 'can_bang_trong_tai',
  IT_SYSTEMS: 'he_thong_it',
  EQUIPMENT: 'thiet_bi_ky_thuat',
  GENERAL: 'kien_thuc_chung',
};

// Course status values
const COURSE_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  OVERDUE: 'overdue',
};

// Course types matching with LMS module
const COURSE_TYPES = {
  INITIAL: 'BAN_ĐẦU',
  PERIODIC: 'ĐỊNH_KỲ',
  SUPPLEMENTAL: 'BỔ_SUNG',
  OTHER: 'KHÁC',
};

// Certificate status values
const CERTIFICATE_STATUS = {
  VALID: 'valid',
  EXPIRED: 'expired',
  EXPIRING_SOON: 'expiring_soon',
};

// Generate realistic expiry dates
const currentDate = new Date();
const getExpiryDate = (monthsToAdd) => {
  const date = new Date(currentDate);
  date.setMonth(date.getMonth() + monthsToAdd);
  return date.toISOString().split('T')[0];
};

// Generate realistic issue dates
const getIssueDate = (monthsAgo) => {
  const date = new Date(currentDate);
  date.setMonth(date.getMonth() - monthsAgo);
  return date.toISOString().split('T')[0];
};

// Mock courses with Vietnamese context matching CoursesPage.tsx
export const MOCK_COURSES = [
  {
    id: 'AGS001',
    title: 'Cân bằng trọng tải tàu A320/A321 hãng Vietnam Airlines (VN)',
    titleEn: 'Load Balancing for A320/A321 Vietnam Airlines Aircraft',
    thumbnail: '/assets/images/courses/load-balancing-a320.jpg',
    category: COURSE_CATEGORIES.LOAD_BALANCING,
    type: COURSE_TYPES.INITIAL,
    duration: '5 ngày',
    progress: 75,
    status: COURSE_STATUS.IN_PROGRESS,
    dueDate: '2025-05-20',
    isRequired: true,
    description: 'Đào tạo nghiệp vụ cân bằng trọng tải và phân phối tải trọng cho các dòng tàu bay A320/A321 của Vietnam Airlines',
    descriptionEn: 'Training on load balancing and weight distribution for Vietnam Airlines A320/A321 aircraft',
    instructor: 'Nguyễn Văn An',
    instructorTitle: 'Chuyên gia Cân bằng trọng tải',
    enrollmentDate: '2025-02-15',
    completionDate: null,
    tags: ['cân bằng trọng tải', 'A320', 'A321', 'Vietnam Airlines'],
    certification: true,
    createdDate: '2025-01-15',
    lastModified: '2025-02-10'
  },
  {
    id: 'AGS002',
    title: 'An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất',
    titleEn: 'Aviation Security for Ground Handling Staff',
    thumbnail: '/assets/images/courses/aviation-security.jpg',
    category: COURSE_CATEGORIES.AVIATION_SAFETY,
    type: COURSE_TYPES.PERIODIC,
    duration: '3 ngày',
    progress: 10,
    status: COURSE_STATUS.IN_PROGRESS,
    dueDate: '2025-05-05',
    isRequired: true,
    description: 'Đào tạo các quy định an ninh hàng không cho nhân viên phục vụ kỹ thuật thương mại mặt đất tại cảng hàng không, sân bay',
    descriptionEn: 'Training on aviation security regulations for ground handling technical staff at airports',
    instructor: 'Trần Thị Lan Anh',
    instructorTitle: 'Chuyên gia An ninh hàng không',
    enrollmentDate: '2025-03-01',
    completionDate: null,
    tags: ['an ninh hàng không', 'mặt đất', 'quy định'],
    certification: true,
    createdDate: '2025-01-20',
    lastModified: '2025-02-05'
  },
  {
    id: 'AGS003',
    title: 'Hệ thống kiểm soát tải của hãng hàng không',
    titleEn: 'Airline Load Control Systems',
    thumbnail: '/assets/images/courses/load-control-systems.jpg',
    category: COURSE_CATEGORIES.IT_SYSTEMS,
    type: COURSE_TYPES.OTHER,
    duration: '4 ngày',
    progress: 15,
    status: COURSE_STATUS.IN_PROGRESS,
    dueDate: '2025-06-15',
    isRequired: false,
    description: 'Đào tạo sử dụng các hệ thống kiểm soát tải của các hãng hàng không quốc tế như Singapore Airlines, EVA Air',
    descriptionEn: 'Training on using load control systems of international airlines such as Singapore Airlines, EVA Air',
    instructor: 'Bùi Văn Long',
    instructorTitle: 'Chuyên gia Hệ thống',
    enrollmentDate: '2025-03-20',
    completionDate: null,
    tags: ['hệ thống IT', 'kiểm soát tải', 'hãng hàng không'],
    certification: true,
    createdDate: '2025-01-10',
    lastModified: '2025-01-25'
  },
  {
    id: 'AGS004',
    title: 'Công tác khẩn nguy tại cảng hàng không, sân bay',
    titleEn: 'Emergency Response at Airports',
    thumbnail: '/assets/images/courses/emergency-response.jpg',
    category: COURSE_CATEGORIES.AVIATION_SAFETY,
    type: COURSE_TYPES.PERIODIC,
    duration: '3 ngày',
    progress: 0,
    status: COURSE_STATUS.NOT_STARTED,
    dueDate: '2025-05-15',
    isRequired: true,
    description: 'Đào tạo quy trình xử lý các tình huống khẩn nguy và ứng phó sự cố tại môi trường cảng hàng không',
    descriptionEn: 'Training on emergency handling procedures and incident response in airport environments',
    instructor: 'Hoàng Văn Thành',
    instructorTitle: 'Chuyên gia An toàn hàng không',
    enrollmentDate: null,
    completionDate: null,
    tags: ['khẩn nguy', 'an toàn', 'sân bay'],
    certification: true,
    createdDate: '2025-01-08',
    lastModified: '2025-02-01'
  },
  {
    id: 'AGS005',
    title: 'Hàng nguy hiểm dành cho người chịu trách nhiệm lên kế hoạch chất xếp',
    titleEn: 'Dangerous Goods for Loading Planners',
    thumbnail: '/assets/images/courses/dangerous-goods.jpg',
    category: COURSE_CATEGORIES.AVIATION_SAFETY,
    type: COURSE_TYPES.PERIODIC,
    duration: '4 ngày',
    progress: 100,
    status: COURSE_STATUS.COMPLETED,
    dueDate: '2023-08-30',
    isRequired: true,
    description: 'Đào tạo quy định vận chuyển hàng nguy hiểm và lập kế hoạch chất xếp an toàn lên tàu bay',
    descriptionEn: 'Training on dangerous goods regulations and safe loading planning for aircraft',
    instructor: 'Lê Hoàng Nam',
    instructorTitle: 'Chuyên gia Hàng nguy hiểm',
    enrollmentDate: '2023-07-15',
    completionDate: '2023-08-20',
    tags: ['hàng nguy hiểm', 'chất xếp', 'an toàn'],
    certification: true,
    createdDate: '2025-01-12',
    lastModified: '2025-01-30'
  },
  {
    id: 'AGS006',
    title: 'Cân bằng trọng tải tàu B787 hãng Vietnam Airlines (VN)',
    titleEn: 'Load Balancing for B787 Vietnam Airlines Aircraft',
    thumbnail: '/assets/images/courses/load-balancing-b787.jpg',
    category: COURSE_CATEGORIES.LOAD_BALANCING,
    type: COURSE_TYPES.INITIAL,
    duration: '6 ngày',
    progress: 100,
    status: COURSE_STATUS.COMPLETED,
    dueDate: '2023-09-15',
    isRequired: true,
    description: 'Nghiệp vụ cân bằng trọng tải chuyên biệt cho dòng tàu bay thân rộng B787 Dreamliner',
    descriptionEn: 'Specialized load balancing for wide-body B787 Dreamliner aircraft',
    instructor: 'Đỗ Minh Tuấn',
    instructorTitle: 'Chuyên gia Cân bằng trọng tải',
    enrollmentDate: '2023-07-01',
    completionDate: '2023-09-10',
    tags: ['cân bằng trọng tải', 'B787', 'Vietnam Airlines'],
    certification: true,
    createdDate: '2025-02-01',
    lastModified: '2025-02-12'
  },
  {
    id: 'AGS007',
    title: 'Khai thác và quản lý thiết bị chất xếp (Chương trình 3)',
    titleEn: 'Operation and Management of Loading Equipment (Program 3)',
    thumbnail: '/assets/images/courses/loading-equipment.jpg',
    category: COURSE_CATEGORIES.EQUIPMENT,
    type: COURSE_TYPES.PERIODIC,
    duration: '7 ngày',
    progress: 100,
    status: COURSE_STATUS.COMPLETED,
    dueDate: '2023-06-30',
    isRequired: true,
    description: 'Đào tạo vận hành, bảo trì và quản lý các thiết bị chất xếp hàng hóa, hành lý tại sân bay',
    descriptionEn: 'Training on operation, maintenance, and management of cargo and baggage loading equipment at airports',
    instructor: 'Phạm Văn Đức',
    instructorTitle: 'Chuyên gia Thiết bị mặt đất',
    enrollmentDate: '2023-06-01',
    completionDate: '2023-06-25',
    tags: ['thiết bị', 'chất xếp', 'quản lý'],
    certification: true,
    createdDate: '2025-01-25',
    lastModified: '2025-02-08'
  },
  {
    id: 'AGS008',
    title: 'Pháp luật về hàng không dân dụng',
    titleEn: 'Civil Aviation Law',
    thumbnail: '/assets/images/courses/aviation-law.jpg',
    category: COURSE_CATEGORIES.GENERAL,
    type: COURSE_TYPES.PERIODIC,
    duration: '2 ngày',
    progress: 0,
    status: COURSE_STATUS.NOT_STARTED,
    dueDate: null,
    isRequired: false,
    description: 'Tổng quan các quy định pháp luật, thông tư, nghị định liên quan đến hoạt động hàng không dân dụng',
    descriptionEn: 'Overview of legal regulations, circulars, and decrees related to civil aviation activities',
    instructor: 'Phạm Thị Mai',
    instructorTitle: 'Chuyên gia Pháp lý Hàng không',
    enrollmentDate: null,
    completionDate: null,
    tags: ['pháp luật', 'hàng không', 'quy định'],
    certification: false,
    createdDate: '2025-01-18',
    lastModified: '2025-02-03',
    recommended: true
  },
  {
    id: 'AGS009',
    title: 'Cân bằng trọng tải tàu A350 hãng Vietnam Airlines (VN)',
    titleEn: 'Load Balancing for A350 Vietnam Airlines Aircraft',
    thumbnail: '/assets/images/courses/load-balancing-a350.jpg',
    category: COURSE_CATEGORIES.LOAD_BALANCING,
    type: COURSE_TYPES.INITIAL,
    duration: '6 ngày',
    progress: 0,
    status: COURSE_STATUS.NOT_STARTED,
    dueDate: null,
    isRequired: false,
    description: 'Nghiệp vụ cân bằng trọng tải cho dòng tàu bay thân rộng A350 với công nghệ hiện đại',
    descriptionEn: 'Load balancing operations for modern A350 wide-body aircraft',
    instructor: 'Nguyễn Văn An',
    instructorTitle: 'Chuyên gia Cân bằng trọng tải',
    enrollmentDate: null,
    completionDate: null,
    tags: ['cân bằng trọng tải', 'A350', 'Vietnam Airlines'],
    certification: true,
    createdDate: '2025-01-22',
    lastModified: '2025-02-06',
    recommended: true
  },
  {
    id: 'AGS010',
    title: 'An ninh hàng không Mỹ',
    titleEn: 'US Aviation Security',
    thumbnail: '/assets/images/courses/us-aviation-security.jpg',
    category: COURSE_CATEGORIES.AVIATION_SAFETY,
    type: COURSE_TYPES.PERIODIC,
    duration: '2 ngày',
    progress: 0,
    status: COURSE_STATUS.NOT_STARTED,
    dueDate: null,
    isRequired: false,
    description: 'Đào tạo các quy định an ninh hàng không theo tiêu chuẩn Mỹ cho các chuyến bay đến/đi Hoa Kỳ',
    descriptionEn: 'Training on US aviation security standards for flights to/from the United States',
    instructor: 'Vũ Thị Mai',
    instructorTitle: 'Chuyên gia An ninh hàng không quốc tế',
    enrollmentDate: null,
    completionDate: null,
    tags: ['an ninh hàng không', 'tiêu chuẩn Mỹ', 'TSA'],
    certification: true,
    createdDate: '2025-01-28',
    lastModified: '2025-02-04',
    recommended: true
  }
];

// Mock classes data matching ClassesListPage.tsx
export const MOCK_CLASSES = [
  {
    id: 'CLS001',
    courseId: 'AGS002',
    title: 'An ninh Hàng không - Khóa K01/2025',
    courseTitle: 'An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất',
    instructor: 'Nguyễn Văn An',
    startDate: '2025-02-15',
    endDate: '2025-02-17',
    status: 'active',
    enrollmentCount: 25,
    enrollmentLimit: 30,
    location: 'Hà Nội',
    schedule: 'T2,T4,T6 - 8:00-17:00',
    room: 'Phòng 101 - Tầng 1',
    organization: {
      id: '5',
      name: 'Phòng An ninh Hàng không',
      type: 'internal',
      department: 'Chi nhánh Hà Nội (HAN-SEC)'
    },
    completionRate: 65
  },
  {
    id: 'CLS002',
    courseId: 'AGS007',
    title: 'Vận hành GSE - Khóa HCM01/2025',
    courseTitle: 'Khai thác và quản lý thiết bị chất xếp (Chương trình 3)',
    instructor: 'Trần Minh Đức',
    startDate: '2025-02-20',
    endDate: '2025-02-24',
    status: 'upcoming',
    enrollmentCount: 18,
    enrollmentLimit: 20,
    location: 'TP.HCM',
    schedule: 'T2-T6 - 8:00-17:00',
    room: 'Xưởng thực hành A',
    organization: {
      id: '3',
      name: 'Phòng Vận hành Mặt đất',
      type: 'internal',
      department: 'Chi nhánh Hồ Chí Minh (SGN-OPS)'
    },
    completionRate: 0
  },
  {
    id: 'CLS003',
    courseId: 'AGS005',
    title: 'Xử lý Hàng nguy hiểm - Khóa DN01/2025',
    courseTitle: 'Hàng nguy hiểm dành cho người chịu trách nhiệm lên kế hoạch chất xếp',
    instructor: 'Lê Thị Hương',
    startDate: '2025-02-10',
    endDate: '2025-02-13',
    status: 'completed',
    enrollmentCount: 25,
    enrollmentLimit: 25,
    location: 'Đà Nẵng',
    schedule: 'T2-T5 - 8:00-17:00',
    room: 'Khu vực Cargo',
    organization: {
      id: '10',
      name: 'Phòng Vận hành Mặt đất',
      type: 'internal',
      department: 'Chi nhánh Đà Nẵng (DAD-OPS)'
    },
    completionRate: 100
  },
  {
    id: 'CLS004',
    courseId: 'AGS001',
    title: 'Cân bằng trọng tải A320/A321 - Khóa HN02/2025',
    courseTitle: 'Cân bằng trọng tải tàu A320/A321 hãng Vietnam Airlines (VN)',
    instructor: 'Phạm Quang Huy',
    startDate: '2025-03-01',
    endDate: '2025-03-06',
    status: 'upcoming',
    enrollmentCount: 12,
    enrollmentLimit: 15,
    location: 'Hà Nội',
    schedule: 'T2-T6 - 7:00-16:00',
    room: 'Phòng thực hành LCS - Tầng 2',
    organization: {
      id: '7',
      name: 'Phòng Vận hành Mặt đất',
      type: 'internal',
      department: 'Chi nhánh Hà Nội (HAN-OPS)'
    },
    completionRate: 0
  },
  {
    id: 'CLS005',
    courseId: 'AGS004',
    title: 'Ứng phó Khẩn nguy - Khóa HCM02/2025',
    courseTitle: 'Công tác khẩn nguy tại cảng hàng không, sân bay',
    instructor: 'Võ Thị Mai',
    startDate: '2025-02-25',
    endDate: '2025-02-26',
    status: 'upcoming',
    enrollmentCount: 28,
    enrollmentLimit: 35,
    location: 'TP.HCM',
    schedule: 'T7,CN - 8:00-17:00',
    room: 'Phòng 205 - Terminal 1',
    organization: {
      id: '4',
      name: 'Phòng An ninh & An toàn',
      type: 'internal',
      department: 'Chi nhánh Hồ Chí Minh (SGN-SEC)'
    },
    completionRate: 0
  },
  {
    id: 'CLS006',
    courseId: 'AGS003',
    title: 'Hệ thống kiểm soát tải - Khóa DN02/2025',
    courseTitle: 'Hệ thống kiểm soát tải của hãng hàng không',
    instructor: 'Hoàng Văn Thành',
    startDate: '2025-03-10',
    endDate: '2025-03-12',
    status: 'upcoming',
    enrollmentCount: 20,
    enrollmentLimit: 25,
    location: 'Đà Nẵng',
    schedule: 'T2,T4,T6 - 8:00-17:00',
    room: 'Phòng máy tính A',
    organization: {
      id: 'EXT001',
      name: 'Trung tâm Đào tạo Hàng không',
      type: 'partner',
      department: 'Đối tác đào tạo chuyên biệt'
    },
    completionRate: 0
  },
  {
    id: 'CLS007',
    courseId: 'AGS006',
    title: 'Cân bằng trọng tải B787 - Khóa HN03/2025',
    courseTitle: 'Cân bằng trọng tải tàu B787 hãng Vietnam Airlines (VN)',
    instructor: 'Nguyễn Công Minh',
    startDate: '2025-03-15',
    endDate: '2025-03-21',
    status: 'upcoming',
    enrollmentCount: 15,
    enrollmentLimit: 20,
    location: 'Hà Nội',
    schedule: 'T2-T6 - 8:00-17:00',
    room: 'Phòng thực hành LCS - Tầng 2',
    organization: {
      id: '7',
      name: 'Phòng Vận hành Mặt đất',
      type: 'internal',
      department: 'Chi nhánh Hà Nội (HAN-OPS)'
    },
    completionRate: 0
  }
];

// Mock certificates data matching CertificationList.tsx
export const MOCK_CERTIFICATES = [
  {
    id: 'CERT-AGS001',
    courseId: 'AGS001',
    name: 'Chứng chỉ Cân bằng trọng tải A320/A321 - Vietnam Airlines',
    nameEn: 'Load Balancing Certificate A320/A321 - Vietnam Airlines',
    certificateCode: 'VN-LCS-A320-2025-001',
    type: 'Hàng không chuyên ngành',
    ownerId: 'EMP-1001',
    ownerName: 'Nguyễn Văn Minh',
    ownerDepartment: 'Cân bằng trọng tải',
    issuer: 'Vietnam Airlines Corporation',
    issueDate: getIssueDate(2),
    expiryDate: getExpiryDate(24),
    status: CERTIFICATE_STATUS.VALID,
    score: 92,
    fileUrl: '/assets/files/certificates/VN-LCS-A320-2025-001.pdf',
    linkedCourseId: 'AGS001',
    linkedCourseName: 'Cân bằng trọng tải tàu A320/A321 hãng Vietnam Airlines (VN)',
    notes: 'Hoàn thành xuất sắc khóa đào tạo cân bằng trọng tải cho dòng tàu A320/A321',
    createdBy: 'training_admin',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-20',
    skills: ['Cân bằng trọng tải', 'A320/A321', 'Kiểm soát tải']
  },
  {
    id: 'CERT-AGS002',
    courseId: 'AGS002',
    name: 'Chứng chỉ An ninh hàng không cho nhân viên mặt đất',
    nameEn: 'Aviation Security Certificate for Ground Staff',
    certificateCode: 'CAAV-SEC-2023-089',
    type: 'An ninh hàng không',
    ownerId: 'EMP-1002',
    ownerName: 'Trần Thị Lan Anh',
    ownerDepartment: 'An ninh & An toàn',
    issuer: 'Cục Hàng không Việt Nam (CAAV)',
    issueDate: getIssueDate(8),
    expiryDate: getExpiryDate(4),
    status: CERTIFICATE_STATUS.EXPIRING_SOON,
    score: 88,
    fileUrl: '/assets/files/certificates/CAAV-SEC-2023-089.pdf',
    linkedCourseId: 'AGS002',
    linkedCourseName: 'An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất',
    notes: 'Cần gia hạn trong vòng 30 ngày tới',
    createdBy: 'security_admin',
    createdAt: '2023-08-15',
    updatedAt: '2025-07-10',
    skills: ['An ninh hàng không', 'Quy trình soi chiếu', 'Quy định ICAO']
  },
  {
    id: 'CERT-AGS003',
    courseId: 'AGS005',
    name: 'Chứng chỉ Vận chuyển hàng nguy hiểm IATA DGR',
    nameEn: 'IATA Dangerous Goods Regulations Certificate',
    certificateCode: 'IATA-DGR-CAT6-2022-156',
    type: 'Quốc tế (IATA)',
    ownerId: 'EMP-1003',
    ownerName: 'Lê Hoàng Nam',
    ownerDepartment: 'Xử lý hàng hóa',
    issuer: 'International Air Transport Association (IATA)',
    issueDate: getIssueDate(15),
    expiryDate: getIssueDate(3),
    status: CERTIFICATE_STATUS.EXPIRED,
    score: 90,
    fileUrl: '/assets/files/certificates/IATA-DGR-CAT6-2022-156.pdf',
    linkedCourseId: 'AGS005',
    linkedCourseName: 'Hàng nguy hiểm dành cho người chịu trách nhiệm lên kế hoạch chất xếp',
    notes: 'Chứng chỉ đã hết hạn, cần tái chứng nhận ngay lập tức',
    createdBy: 'cargo_admin',
    createdAt: '2022-11-10',
    updatedAt: '2025-01-05',
    skills: ['Hàng nguy hiểm', 'IATA DGR', 'Chất xếp hàng hóa']
  },
  {
    id: 'CERT-AGS004',
    courseId: 'AGS007',
    name: 'Chứng chỉ Khai thác thiết bị mặt đất GSE',
    nameEn: 'Ground Support Equipment Operations Certificate',
    certificateCode: 'GSE-OPR-2025-012',
    type: 'Thiết bị kỹ thuật',
    ownerId: 'EMP-1004',
    ownerName: 'Phạm Văn Đức',
    ownerDepartment: 'Thiết bị & Kỹ thuật',
    issuer: 'Sân bay Quốc tế Nội Bài',
    issueDate: getIssueDate(2),
    expiryDate: getExpiryDate(34),
    status: CERTIFICATE_STATUS.VALID,
    score: 95,
    fileUrl: '/assets/files/certificates/GSE-OPR-2025-012.pdf',
    linkedCourseId: 'AGS007',
    linkedCourseName: 'Khai thác và quản lý thiết bị chất xếp (Chương trình 3)',
    notes: 'Được cấp sau khi hoàn thành khóa đào tạo chuyên sâu về GSE',
    createdBy: 'equipment_admin',
    createdAt: '2025-02-05',
    updatedAt: '2025-02-05',
    skills: ['Thiết bị mặt đất', 'Vận hành GSE', 'Bảo trì thiết bị']
  },
  {
    id: 'CERT-AGS005',
    courseId: 'AGS010',
    name: 'Chứng chỉ An ninh hàng không Mỹ (TSA)',
    nameEn: 'US Aviation Security Certificate (TSA)',
    certificateCode: 'TSA-US-SEC-2025-033',
    type: 'Quốc tế (TSA)',
    ownerId: 'EMP-1005',
    ownerName: 'Vũ Thị Mai',
    ownerDepartment: 'An ninh & An toàn',
    issuer: 'Transportation Security Administration (TSA)',
    issueDate: getIssueDate(2),
    expiryDate: getExpiryDate(10),
    status: CERTIFICATE_STATUS.VALID,
    score: 92,
    fileUrl: '/assets/files/certificates/TSA-US-SEC-2025-033.pdf',
    linkedCourseId: 'AGS010',
    linkedCourseName: 'An ninh hàng không Mỹ',
    notes: 'Chứng nhận cho các chuyến bay đến/đi Hoa Kỳ',
    createdBy: 'security_admin',
    createdAt: '2025-01-28',
    updatedAt: '2025-01-28',
    skills: ['An ninh hàng không', 'TSA', 'Tiêu chuẩn Mỹ']
  }
];

// Mock learning progress data
export const MOCK_LEARNING_PROGRESS = {
  inProgress: 3,
  completed: 3,
  totalAssigned: 7,
  totalAvailable: 10,
  completionRate: Math.round((3 / 7) * 100),
  certificatesEarned: 5,
  activeClasses: 1,
  upcomingClasses: 4,
  completedClasses: 2,
  totalQuizzesTaken: 12,
  totalQuizzesPassed: 10,
  averageScore: 88,
  totalTimeSpent: '32h 15m',
  lastAccessDate: new Date().toISOString().split('T')[0]
};

// Mock recent activity data
export const MOCK_RECENT_ACTIVITY = [
  {
    id: 1,
    type: 'course_progress',
    course: 'Cân bằng trọng tải tàu A320/A321 hãng Vietnam Airlines (VN)',
    courseId: 'AGS001',
    progress: 75,
    date: '2025-03-15'
  },
  {
    id: 2,
    type: 'class_enrolled',
    course: 'An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất',
    courseId: 'AGS002',
    className: 'An ninh Hàng không - Khóa K01/2025',
    date: '2025-02-15'
  },
  {
    id: 3,
    type: 'certificate_earned',
    course: 'Hàng nguy hiểm dành cho người chịu trách nhiệm lên kế hoạch chất xếp',
    courseId: 'AGS005',
    certificateName: 'Chứng chỉ Vận chuyển hàng nguy hiểm IATA DGR',
    date: '2023-11-10'
  },
  {
    id: 4,
    type: 'course_started',
    course: 'Hệ thống kiểm soát tải của hãng hàng không',
    courseId: 'AGS003',
    date: '2025-03-20'
  },
  {
    id: 5,
    type: 'quiz_completed',
    course: 'An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất',
    courseId: 'AGS002',
    quizName: 'Kiểm tra An ninh hàng không cơ bản',
    score: 85,
    date: '2025-03-05'
  },
  {
    id: 6,
    type: 'content_viewed',
    course: 'Cân bằng trọng tải tàu A320/A321 hãng Vietnam Airlines (VN)',
    courseId: 'AGS001',
    contentName: 'Kỹ thuật phân phối tải trọng',
    date: '2025-03-12'
  }
];

// Mock upcoming deadlines
export const MOCK_UPCOMING_DEADLINES = [
  {
    id: 1,
    courseId: 'AGS002',
    course: 'An ninh hàng không dành cho nhân viên phục vụ kỹ thuật thương mại mặt đất',
    dueDate: '2025-05-05',
    progress: 10,
    isRequired: true
  },
  {
    id: 2,
    courseId: 'AGS004',
    course: 'Công tác khẩn nguy tại cảng hàng không, sân bay',
    dueDate: '2025-05-15',
    progress: 0,
    isRequired: true
  },
  {
    id: 3,
    courseId: 'AGS001',
    course: 'Cân bằng trọng tải tàu A320/A321 hãng Vietnam Airlines (VN)',
    dueDate: '2025-05-20',
    progress: 75,
    isRequired: true
  },
  {
    id: 4,
    courseId: 'AGS003',
    course: 'Hệ thống kiểm soát tải của hãng hàng không',
    dueDate: '2025-06-15',
    progress: 15,
    isRequired: false
  }
];

// Export combined mock data
export const MOCK_DATA = {
  courses: MOCK_COURSES,
  classes: MOCK_CLASSES,
  certificates: MOCK_CERTIFICATES,
  learningProgress: MOCK_LEARNING_PROGRESS,
  recentActivity: MOCK_RECENT_ACTIVITY,
  upcomingDeadlines: MOCK_UPCOMING_DEADLINES,
  // Helper for getting filtered lists
  getInProgressCourses: () => MOCK_COURSES.filter(course => course.status === COURSE_STATUS.IN_PROGRESS),
  getCompletedCourses: () => MOCK_COURSES.filter(course => course.status === COURSE_STATUS.COMPLETED),
  getNotStartedCourses: () => MOCK_COURSES.filter(course => course.status === COURSE_STATUS.NOT_STARTED),
  getOverdueCourses: () => MOCK_COURSES.filter(course => course.status === COURSE_STATUS.OVERDUE),
  getRecommendedCourses: () => MOCK_COURSES.filter(course => course.recommended),
  getValidCertificates: () => MOCK_CERTIFICATES.filter(cert => cert.status === CERTIFICATE_STATUS.VALID),
  getExpiredCertificates: () => MOCK_CERTIFICATES.filter(cert => cert.status === CERTIFICATE_STATUS.EXPIRED),
  getExpiringCertificates: () => MOCK_CERTIFICATES.filter(cert => cert.status === CERTIFICATE_STATUS.EXPIRING_SOON),
  getActiveClasses: () => MOCK_CLASSES.filter(cls => cls.status === 'active'),
  getUpcomingClasses: () => MOCK_CLASSES.filter(cls => cls.status === 'upcoming'),
  getCompletedClasses: () => MOCK_CLASSES.filter(cls => cls.status === 'completed')
}; 